import React, { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';

const FrequencyDashboardCard = ({ title, value, onUpdate }) => {
  const [newValue, setNewValue] = useState(value);
  const [alert, setAlert] = useState({ open: false, severity: 'info', message: '' });

  useEffect(() => {
    setNewValue(value);
  }, [value]);

  const handleUpdateClick = async () => {
    const parsedValue = parseInt(newValue, 10);
    if (!isNaN(parsedValue) && parsedValue > 0) {
      try {
        await onUpdate(parsedValue);
        setAlert({ open: true, severity: 'success', message: 'Frecuencia actualizada correctamente' });
      } catch (error) {
        setAlert({ open: true, severity: 'error', message: 'Error al actualizar la frecuencia' });
      }
    } else {
      setAlert({ open: true, severity: 'error', message: 'Ingrese un número válido mayor a 0' });
    }
  };

  return (
    <div className="dashboard-card">
      <div className="card-title">{title}</div>
      <div className="input-container">
        <input
          type="number"
          value={newValue}
          onChange={(e) => setNewValue(e.target.value)}
          min="1"
          className="input-field"
        />
        <button className="update-button" onClick={handleUpdateClick}>
          Actualizar
        </button>
      </div>

      {/* Snackbar para mensajes de éxito o error */}
      <Snackbar
          open={alert.open}
          autoHideDuration={3000}
          onClose={() => setAlert({ ...alert, open: false })}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity={alert.severity} onClose={() => setAlert({ ...alert, open: false })}>
          {alert.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default FrequencyDashboardCard;
